export const INFO_STATUSES = {
    saveSKUBeforrImageUpload: {
        bg: "Запазете вариацията преди да качите снимките за нея !",
        en: "Save the variation first to add images!"
    }
}